import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { Router }              from '@angular/router';
import { Step4 }            from '../data/formData.model';
import { FormDataService }     from '../data/formData.service';
import { GermanAddress } from '@angular-material-extensions/google-maps-autocomplete';
import {FormControl, Validators, FormGroup, FormBuilder} from '@angular/forms';
import PlaceResult = google.maps.places.PlaceResult;

@Component({
  selector: 'app-art-wohnung-step4',
  templateUrl: './art-wohnung-step4.component.html',
  styleUrls: ['./art-wohnung-step4.component.scss']
})
export class ArtWohnungStep4Component implements OnInit {

  title = 'Bitte geben Sie Baujahr und Objekt Zustand an';
  form: any;
  step4: Step4;
  locationCheck: boolean = false;
  placestring: GermanAddress;
  addressFormGroup: FormGroup;
  types: Array<Object> = ['address'];
  strictBounds: boolean = true;
  addressLabelText: string = "Suche Adresse";
  testForm: FormGroup;
  allowedChars = new Set('0123456789'.split('').map(c => c.charCodeAt(0)));

  // check(event: KeyboardEvent) {
 
  //   // 31 and below are control keys, don't block them.
  //   if (event.keyCode > 31 && !this.allowedChars.has(event.keyCode)) {
  //     event.preventDefault();
  //   }
  // }

  constructor(private router: Router, private formDataService: FormDataService) {
  }

  onAutocompleteSelected(result: PlaceResult) {
    console.log('onAutocompleteSelected: ', result);
    
    for(let i = 0; i < result.address_components.length; i++){
      if(result.address_components[i].types[0] == 'postal_code'){
        this.step4.postalcode = Number(result.address_components[i].long_name);
      }
      if(result.address_components[i].types[0] == 'locality'){
        this.step4.city = result.address_components[i].long_name;
      }
      if(result.address_components[i].types[0] == 'street_number'){
        this.step4.address2 = result.address_components[i].long_name;
      }
      if(result.address_components[i].types[0] == 'route'){
        this.step4.address = result.address_components[i].long_name;
      }
    }
  }

  ngOnInit() {
      this.step4 = this.formDataService.getStep4();
      console.log('Region und geschätzter Verkaufswert feature loaded!');

      this.placestring = this.step4.placestring;

      this.testForm = new FormGroup({
        price: new FormControl('', [ Validators.required, Validators.min(10000), Validators.max(99999999) ] )
      });
  }

  save(form: any): boolean {
      if (!form.valid) {
          return false;
      }
      this.formDataService.setStep4(this.step4);
      return true;
  }

  goToNext(form: any) {
      if (this.save(form)) {
        this.sendMessage('movetop');
        this.router.navigate(['/haus-step5']);
      }
  }

  goToPrevious(form: any) {
    this.sendMessage('movetop');
    this.router.navigate(['/haus-step3']);
  }

  // Send a message to the parent
  sendMessage(msg: string) {
    window.parent.postMessage(msg, '*');
   }

}
